import React from 'react'

const Aside = () => {
  return (
    <div>Aside</div>
  )
}

export default Aside